// 用户实名认证
const state = {
    authInfo: null
}
const getters = {
    authInfo(state) {
        return state.authInfo;
    }
}
const mutations = {
    setAuthInfo(state,data) {
        state.authInfo = data;
    }
}
export default {
    state,
    getters,
    mutations
}
